import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Hero() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleSmoothScroll = (e: React.MouseEvent<HTMLAnchorElement>, targetId: string) => {
    e.preventDefault();
    const element = document.querySelector(targetId);
    if (element) {
      const navHeight = 80; // Account for fixed navigation height
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - navHeight;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="home" className="relative h-screen w-full overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/2375017f394d10fcfb4444aa68ebb307.jpg"
          alt="Hero Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-8 py-6 flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <img 
              src="https://public.readdy.ai/ai/img_res/69b64890-bab3-4245-94d5-7709b240f790.png" 
              alt="Melinda Holcomb Logo" 
              className="h-12 w-auto"
            />
          </Link>
          <div className="flex items-center gap-8">
            <a 
              href="#home" 
              onClick={(e) => handleSmoothScroll(e, '#home')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${scrolled ? 'text-gray-800 hover:text-teal-600' : 'text-white hover:text-teal-400'}`}
            >
              Home
            </a>
            <a 
              href="#about" 
              onClick={(e) => handleSmoothScroll(e, '#about')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${scrolled ? 'text-gray-800 hover:text-teal-600' : 'text-white hover:text-teal-400'}`}
            >
              About
            </a>
            <a 
              href="#books" 
              onClick={(e) => handleSmoothScroll(e, '#books')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${scrolled ? 'text-gray-800 hover:text-teal-600' : 'text-white hover:text-teal-400'}`}
            >
              Books
            </a>
            <Link 
              to="/videos" 
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${scrolled ? 'text-gray-800 hover:text-teal-600' : 'text-white hover:text-teal-400'}`}
            >
              Videos
            </Link>
            <a 
              href="#blog" 
              onClick={(e) => handleSmoothScroll(e, '#blog')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${scrolled ? 'text-gray-800 hover:text-teal-600' : 'text-white hover:text-teal-400'}`}
            >
              Blog
            </a>
            <a 
              href="#contact" 
              onClick={(e) => handleSmoothScroll(e, '#contact')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${scrolled ? 'text-gray-800 hover:text-teal-600' : 'text-white hover:text-teal-400'}`}
            >
              Contact
            </a>
          </div>
        </div>
      </nav>

      {/* Hero Content */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center px-8">
        <div className="text-center max-w-4xl">
          <h1 className="font-serif text-7xl md:text-8xl font-bold text-white mb-6 tracking-tight leading-tight">
            Melinda Holcomb
          </h1>
          <p className="text-xl md:text-2xl text-white/90 mb-4 font-light leading-relaxed">
            Survivor of Childhood Trauma
          </p>
          <p className="text-xl md:text-2xl text-white/90 mb-12 font-light leading-relaxed">
            Guiding Others from Darkness to Light
          </p>
          <a 
            href="#books" 
            onClick={(e) => handleSmoothScroll(e, '#books')}
            className="inline-flex items-center gap-4 bg-white text-gray-900 px-8 py-4 rounded-full text-base font-medium hover:bg-gray-100 transition-all duration-300 hover:shadow-xl hover:scale-105 whitespace-nowrap group cursor-pointer"
          >
            <span>Explore My Journey</span>
            <div className="w-10 h-10 bg-gray-900 rounded-full flex items-center justify-center group-hover:bg-teal-600 transition-colors">
              <i className="ri-arrow-right-line text-white text-lg"></i>
            </div>
          </a>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="animate-bounce">
          <i className="ri-arrow-down-line text-white text-3xl"></i>
        </div>
      </div>
    </section>
  );
}